/**
 * Field schemas for each CMS section.
 * type: 'text' | 'textarea' | 'number' | 'url' | 'json'
 * json fields with subfields use RepeaterField for add/remove/reorder.
 */

export const SECTION_SCHEMAS = {
  hero: [
    { key: 'eyebrow', label: 'Eyebrow Text (pill badge)', type: 'text' },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
    { key: 'cta_primary', label: 'Primary CTA Label', type: 'text' },
    { key: 'cta_secondary', label: 'Secondary CTA Label', type: 'text' },
    {
      key: 'tags',
      label: 'Stats Tags',
      type: 'json',
      subfields: [
        { key: 'value', label: 'Value (e.g. 20+)', type: 'text', required: true },
        { key: 'label', label: 'Label (e.g. Years of Experience)', type: 'text', required: true },
      ],
    },
  ],

  servicesHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  industriesHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
    { key: 'banner_image', label: 'Banner Image', type: 'url', mediaPicker: true },
  ],

  portfolioHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
  ],

  caseStudyHome: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
  ],

  valuesHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  techHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
  ],

  testimonialsHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
  ],

  clientsHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
  ],

  reviewsHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  careerHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading (use {N} for job count)', type: 'textarea', rows: 2 },
  ],

  contactHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  whyMgsHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  teamHeader: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'subhead', label: 'Subheading', type: 'textarea', rows: 3 },
  ],

  careerNote: [
    { key: 'text', label: 'Note Text', type: 'textarea', rows: 4, required: true },
  ],

  ctaBand: [
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    { key: 'form_title', label: 'Form Title', type: 'text' },
  ],

  achievements: [
    { key: 'eyebrow', label: 'Eyebrow', type: 'text' },
    { key: 'heading', label: 'Heading', type: 'text', required: true },
    {
      key: 'stats',
      label: 'Stats',
      type: 'json',
      subfields: [
        { key: 'label', label: 'Label (e.g. Years Experience)', type: 'text', required: true },
        { key: 'value', label: 'Value (number)', type: 'number', required: true },
        { key: 'suffix', label: 'Suffix (e.g. +)', type: 'text' },
      ],
    },
  ],
};

export const SECTION_LABELS = {
  hero: 'Hero Banner',
  servicesHeader: 'Services · Header',
  industriesHeader: 'Industries · Header',
  achievements: 'Company Achievements',
  portfolioHeader: 'Portfolio · Header',
  caseStudyHome: 'Case Studies · Header',
  valuesHeader: 'Values · Header',
  techHeader: 'Technologies · Header',
  testimonialsHeader: 'Testimonials · Header',
  clientsHeader: 'Clients · Header',
  ctaBand: 'CTA Band',
  reviewsHeader: 'Reviews · Header',
  careerHeader: 'Career · Header',
  contactHeader: 'Contact · Header',
  whyMgsHeader: 'Why MGS · Header',
  teamHeader: 'Our Team · Header',
  careerNote: 'Career · Side Note',
};

export const SECTION_GROUPS = [
  { label: 'Home Page', keys: ['hero', 'achievements', 'ctaBand'] },
  { label: 'Services Page', keys: ['servicesHeader'] },
  { label: 'Industries Page', keys: ['industriesHeader'] },
  { label: 'Portfolio Page', keys: ['portfolioHeader'] },
  { label: 'Case Studies Page', keys: ['caseStudyHome'] },
  { label: 'Why MGS Page', keys: ['whyMgsHeader'] },
  { label: 'Our Team Page', keys: ['teamHeader'] },
  { label: 'Reviews Page', keys: ['reviewsHeader'] },
  { label: 'Career Page', keys: ['careerHeader', 'careerNote'] },
  { label: 'Contact Page', keys: ['contactHeader'] },
];
